import { DeleteOrderDialog } from '@/components/DeleteOrderDialog';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { useAdminOrders } from '@/hooks/useOrder';
import type { Order } from '@octave/contracts';
import { Package } from 'lucide-react';
import { useState } from 'react';
import { createColumns } from './admin-orders/columns';
import { DataTable } from './admin-orders/data-table';

export function AdminOrderView() {
  const { data: orders, isLoading } = useAdminOrders();
  const [orderToDelete, setOrderToDelete] = useState<Order | null>(null);

  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-full">
        <div className="text-center">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary mx-auto"></div>
          <p className="mt-2 text-muted-foreground">
            Chargement des commandes...
          </p>
        </div>
      </div>
    );
  }

  const columns = createColumns({ onDelete: setOrderToDelete });

  return (
    <div className="space-y-8">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold text-slate-900">
            Toutes les commandes
          </h1>
          <p className="text-sm text-slate-500 mt-1">
            Vue administrateur de toutes les commandes entrantes
          </p>
        </div>
      </div>

      <Card className="group hover:shadow-xl hover:shadow-primary/10 transition-all duration-300 border-0 bg-gradient-to-br from-white to-gray-50/50 dark:from-gray-900 dark:to-gray-800/50 overflow-hidden">
        <CardHeader>
          <CardTitle className="flex items-center gap-2 text-gray-900 dark:text-gray-100">
            <div className="p-2 bg-primary/10 rounded-lg">
              <Package className="h-5 w-5 text-primary" />
            </div>
            Commandes entrantes
          </CardTitle>
        </CardHeader>
        <CardContent>
          {orders && orders.length === 0 ? (
            <div className="text-center py-12">
              <div className="text-muted-foreground text-6xl mb-4">📦</div>
              <p className="text-muted-foreground text-lg">
                Aucune commande trouvée
              </p>
            </div>
          ) : (
            <DataTable columns={columns} data={orders || []} />
          )}
        </CardContent>
      </Card>

      <DeleteOrderDialog
        order={orderToDelete}
        onClose={() => setOrderToDelete(null)}
      />
    </div>
  );
}
